import Navbar from "@/components/layout/Navbar";
import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

interface PageShellProps {
  children: ReactNode;
  /** Escape hatch for the content container — the default is the shared page-width rule. */
  className?: string;
}

/**
 * The standard authenticated page frame: background, Navbar, and the one content-width rule
 * (`container mx-auto px-4 py-6`). Pages render their content as children instead of repeating
 * those classes, so page width and padding change in one place.
 *
 * Not for full-bleed pages (the org chart canvas) or pages without a Navbar (Auth, NotFound).
 */
export function PageShell({ children, className }: PageShellProps) {
  return (
    <div className="min-h-screen bg-gradient-subtle">
      <Navbar />
      <main className={cn("container mx-auto px-4 py-6", className)}>{children}</main>
    </div>
  );
}
